export default {
  TAGS_UPDATED: 'Tags updated',
  NEW_TAG_CLICKED: 'New tag clicked',
  TAG_CREATION_CANCELED: 'Tag creation canceled'
};
